module.exports = ".item-quantity {\r\n    -ms-grid-row-align: center;\r\n        align-self: center;\r\n}"